import { ChangeDetectionStrategy, Component, computed } from '@angular/core'
import { RouterModule } from '@angular/router'

import { HeroOverlay } from 'app/core/cms/generated/api-types'
import { PictureComponent } from 'app/shared/picture/picture.component'

import { CmsBlock } from '../../cms-block'

@Component({
  selector: 'pai-hero-overlay',
  templateUrl: './hero-overlay.component.html',
  styleUrls: ['./hero-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterModule, PictureComponent],
  providers: [{ provide: CmsBlock, useExisting: HeroOverlayComponent }],
})
export class HeroOverlayComponent extends CmsBlock<HeroOverlay> {
  readonly __typename = 'HeroOverlay'
  readonly cta = computed(() => this.data()?.cta?.[0] ?? null)
}
